<ul
  [attr.role]="credentials().length > 1 ? null : 'none'"
  class="credential-selection-list"
  infinite-scroll
  infiniteScrollContainer="mat-sidenav-content"
  [fromRoot]="true"
  (scrolled)="fetchMore.emit()">
  @for (credential of credentials(); track credential.id) {
    <accredible-credential-selection-tile
      role="listitem"
      [credential]="credential"
      [disableSelection]="credential.disabled"
      (selectionChange)="onSelectionChange(credential.id, $event, credential)" />
  }
</ul>
